export const MuiInputAdornment = {
    MuiInputAdornment: {
        styleOverrides: {
            root: {
                '& > .MuiIconButton-root': {
                    '&:focus': {
                        backgroundColor: 'transparent',
                    },
                },
            },
        },
    },
};
